module.exports = __webpack_public_path__ + "static/img/order_empty.cd679c3c.svg";